import { Component, input, Input, InputSignal, OnInit } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ShipmentAppEntityShipmentRead } from '../../../../../openapi';
import { DatePipe, DecimalPipe, NgIf } from '@angular/common';
import { LabelComponent } from '../../../../../common/label/label.component';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { AlertComponent } from '../../../../../common/alert/alert.component';
import { ParcelsPreviewComponent } from '../../common/components/parcels/parcels-preview/parcels-preview.component';
import { ToNumberPipe } from '../../../../../pipes/to-number.pipe';

@Component({
  selector: 'app-approval-of-traffic-organization-projects-preview',
  standalone: true,
  imports: [
    DatePipe,
    LabelComponent,
    DecisionDataPreviewComponent,
    NgIf,
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    AgreementsDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    AlertComponent,
    ParcelsPreviewComponent,
    DecimalPipe,
    ToNumberPipe
  ],
  templateUrl: './approval-of-traffic-organization-projects-preview.component.html'
})
export class ApprovalOfTrafficOrganizationProjectsPreviewComponent implements OnInit {

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  constructor() {
  }

  public ngOnInit(): void {
  }
}
